import { LeaveDay } from "../Hooks/useFerieApi";
import Month from "./Month";
import Grid from '@mui/material/Grid';

interface YearProps {
    year: number;
    vacation?: LeaveDay[];
    onVacationUpdate?: (updatedVacation: LeaveDay[]) => void;
    activityType?: number;
}

const Year: React.FC<YearProps> = (props:YearProps) => {
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
    return (
        <div>
            <Grid container spacing={0} >
                {months.map((monthIndex) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={`month-${monthIndex}`}
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Month month={monthIndex} year={props.year} vacation={props.vacation} onVacationUpdate={props.onVacationUpdate}
                         activityType={props.activityType}/>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};
export default Year;
